import React, { useMemo } from "react";
import SwimmingPoolStage from "../stages/SwimmingPoolStage";
import useResponsiveStageAsset from "../../../hooks/useResponsiveStageAsset";
import StagePageLayout from "./StagePageLayout";

export default function SwimmingStagePage({ stage, onDone, onSessionPointsChange }) {
  const svgAsset = useResponsiveStageAsset(stage.assets);
  const data = useMemo(() => ({ ...stage.data, svgAsset: svgAsset || stage.data.svgAsset }), [stage, svgAsset]);
  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme}>
      <SwimmingPoolStage data={data} onDone={onDone} onSessionPointsChange={onSessionPointsChange} />
    </StagePageLayout>
  );
}
